import React, { Component } from 'react';
import './HelpLinkUtil/helpLink.css'
import HelpUtil from './HelpLinkUtil/HelpUtil';

export default class HelpGeneratedMessage extends Component{
    render() {
        return <div className='help-doc'>
            <div className='markdown'>
                {HelpUtil.renderHeader('Generated Message (India)')}
                {this.renderContent()}
            </div>

        </div>
    }


    renderContent() {
        var data = {
            header: "Signature",
            paragraph: [
                {
                    type: 'text',
                    value: "You can refer to genetated message option from the left panel. The actions that you can performance as below,",
                },
                {
                    type: 'list',
                    value: [
                        "Show/Hide",
                        "Update generated message text",
                        "Reset generated message",
                    ]
                },
                {
                    type: 'image',
                    value: require('./../asset/generated-message/generated-message.png'),
                    isFullWidth: false,
                },
                {
                    type: 'newLine',
                },
                {
                    type: 'text',
                    value: "Sample (Hide generated message)",
                },
                {
                    type: 'image',
                    value: require('./../asset/generated-message/generated-message-hide.png'),
                    isFullWidth: false,
                },
                {
                    type: 'newLine',
                },
                {
                    type: 'newLine',
                },
                {
                    type: 'text',
                    value: "Sample (Show generated message)",
                },
                {
                    type: 'image',
                    value: require('./../asset/generated-message/generated-message-show.png'),
                    isFullWidth: false,
                },
                {
                    type: 'newLine',
                },
                {
                    type: 'newLine',
                },
                {
                    type: 'text',
                    value: "Sample (Change generated message)",
                },
                {
                    type: 'image',
                    value: require('./../asset/generated-message/generated-message-edit.png'),
                    isFullWidth: false,
                },
                {
                    type: 'newLine',
                },
                {
                    type: 'newLine',
                },
            ]
        }
        return <div>
            {HelpUtil.renderParagraphWithJsonData(data)}
        </div>
    }
}